import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useParams } from 'react-router-dom'
import API from '../../../../services/API'
import { Avatar, Box, Paper, Stack, Typography } from '@mui/material'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import Check from '@mui/icons-material/Check'
import Cancel from '@mui/icons-material/Cancel'

const VehicleCleanReport = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [report, setReport] = useState({})
  const [fetchError, setFetchError] = useState(false)

  useEffect(() => {
    API.get('/vehicle-clean-report/' + id).then((res) => {
      if (res.status === 200) {
        setReport(res.data)
        console.log('report', res.data)
      }
    })
  }, [])

  return (
    <Stack gap={2} component={Paper} padding={1}>
      <Typography variant="title2">Vehicle Clean Report</Typography>
      <DetailsBox
        title="Clean Details"
        rows={[
          {
            label: 'Start',
            value: moment(report.start).format('DD.MM.YYYY HH:mm'),
          },
          {
            label: 'End',
            value: moment(report.end).format('DD.MM.YYYY HH:mm'),
          },
          {
            label: 'Operative',
            value:
              report.operative?.userAccount?.firstName +
              ' ' +
              report.operative?.userAccount?.lastName,
          },
          { label: 'Clean Type', value: report.cleanType },
          ...(report.cleanType === 'Decontamination'
            ? [
                {
                  label: 'Decontamination Reason',
                  value: report.deconReason,
                  fullWidthLabel: true,
                  fullWidth: true,
                },
              ]
            : []),
          {
            label: 'ATP Test Done',
            value: report.atpTestCompleted ? 'Yes' : 'No',
          },
          ...(report.atpTestCompleted
            ? [
                {
                  label: 'ATP Test Type',
                  value: report.atpTestType,
                },
              ]
            : []),
          ...(report.atpTestCompleted
            ? [
                {
                  label: 'ATP Test Passed',
                  value:
                    report.atpTestPassed === true
                      ? 'Yes'
                      : report.atpTestPassed === false
                      ? 'No'
                      : '',
                },
              ]
            : []),
          ...(report.cleanType !== 'Interim'
            ? [
                {
                  label: 'Deep Clean Overdue',
                  value: report.deepCleanOverdue ? 'Yes' : 'No',
                },
              ]
            : []),
          ...(report.deepCleanOverdue
            ? [
                {
                  label: 'Exemption',
                  value: report.delayedDeepCleanExemption,
                  fullWidth: true,
                },
              ]
            : []),
        ]}
      />

      {Object.keys(report?.cleanResults ?? []).length > 0 && (
        <Stack gap={2}>
          {Object.keys(report?.cleanResults).map((category) => (
            <DetailsBox
              key={category}
              title={category}
              fullWidthLabels
              rows={report.cleanResults[category].map((item) => ({
                label: item.title,
                value: (
                  <Box display="flex" alignItems="center">
                    {item.value ? (
                      <Check color="success" />
                    ) : (
                      <Cancel color="error" />
                    )}
                  </Box>
                ),
              }))}
            />
          ))}
        </Stack>
      )}
    </Stack>
  )
}

export default VehicleCleanReport
